export default __webpack_public_path__ + "static/media/hair-transplantationp.b6dbd93f.pdf";